import { render, staticRenderFns } from "./DateRangeText.vue?vue&type=template&id=3a112376&"
import script from "./DateRangeText.vue?vue&type=script&lang=js&"
export * from "./DateRangeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports